import { useLang } from "@/i18n/LangContext";
import { useSite } from "@/context/SiteContext";
import { Container, SectionHeader } from "@/components/common";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { linkifyPhones } from "@/lib/phones";

/** FAQs of the CMS collection assigned to a page key (home, rooms, corporate, events, restaurant, location). */
export function usePageFaqs(page) {
  const { faqs } = useSite();
  return faqs.filter((f) => (f.page || "location") === page).sort((a, b) => a.order - b.order);
}

export function FaqSection({ faqs, eyebrow, title, className = "bg-sand", testId = "faqs" }) {
  const { L } = useLang();
  if (!faqs.length) return null;
  return (
    <section className={`${className} py-20 md:py-28`} data-testid={testId}>
      <Container>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4"><SectionHeader eyebrow={eyebrow} title={title} /></div>
          <div className="lg:col-span-8">
            <Accordion type="single" collapsible className="border-t border-line-md">
              {faqs.map((f, i) => (
                <AccordionItem key={f.id} value={f.id} className="border-b border-line-md">
                  <AccordionTrigger data-testid={`${testId}-trigger-${i}`} className="py-6 text-left font-serif text-xl md:text-2xl text-charcoal hover:no-underline [&>svg]:text-terra">{L(f.q)}</AccordionTrigger>
                  <AccordionContent className="pb-6 text-base leading-relaxed text-charcoal/70">{linkifyPhones(L(f.a))}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </Container>
    </section>
  );
}
